/*
 * Copyright (c) 2025 CalAmp Corp.  All Rights Reserved
 */

import React from 'react';
import Render from '../render/Render';
import {IconProps, IconSize} from '../types/types';
import useIconDLS from './useIconDLS';

interface PushPinIconProps extends IconProps {
  filled?: boolean;
}

/**
 * Defines the Design Language System (DLS) Push Pin Icon component.
 *
 * Renders a push pin icon in either an outlined or filled style.
 *
 * @param filled When true, displays the filled variant. When false (default), 
 *               displays the outlined variant.
 */
export const PushPinIcon = ({
  filled = false,
  size = IconSize.small,
  ...rest
}: PushPinIconProps) => {
  const {iconSize, iconColor} = useIconDLS({size, ...rest});

  const commonPathProps = {
    stroke      : iconColor,
    fill        : iconColor,
    strokeWidth : 0.1
  } as const;

  return (
    <svg viewBox='0 0 24 24' width={iconSize} height={iconSize} fill='none'>
      <Render>
        <Render.If condition={filled}>
          <path d='M16 9V4h1c.55 0 1-.45 1-1s-.45-1-1-1H7c-.55 0-1 .45-1 1s.45 1 1 1h1v5c0 1.66-1.34 3-3 3v2h5.97v7l1 1 1-1v-7H19v-2c-1.66 0-3-1.34-3-3'
            fillRule='evenodd'
            {...commonPathProps} />
        </Render.If>
        <Render.Else>
          <path d='M14 4v5c0 1.12.37 2.16 1 3H9c.65-.86 1-1.9 1-3V4zm3-2H7c-.55 0-1 .45-1 1s.45 1 1 1h1v5c0 1.66-1.34 3-3 3v2h5.97v7l1 1 1-1v-7H19v-2c-1.66 0-3-1.34-3-3V4h1c.55 0 1-.45 1-1s-.45-1-1-1'
            {...commonPathProps} />
        </Render.Else>
      </Render>
    </svg>
  );
};
